<template>
    <div class="change-date">
        <h5>No llegamos a tiempo de suministrarle la variedad que has seleccionado.</h5>
        <p>Selecciona entre la fecha más temprana posible o escoge otra fecha</p>
        <b-button class="btn" variant="outline-light" @click="clickDateOffer">
            {{ dateFormatted }}
        </b-button>
        <b-button class="btn" variant="outline-light" style="margin-top: 0.5em" @click="clickOtherDate">
            Escoger otra fecha
        </b-button>
    </div>
</template>

<script>
    export default {
        name: "ChangeDateVariety",
        props: {
            date: {
                type: Date,
                default: () => moment().toDate()
            }
        },
        computed: {
            dateFormatted() {
                return moment(this.date).format('dddd D [de] MMMM YYYY');
            },
        },
        methods: {
            clickOtherDate() {
                this.$emit('other-date');
            },
            clickDateOffer() {
                this.$emit('date-selected');
            }
        }
    }
</script>

<style scoped>
    .change-date {
        background-color: #c2282d;
        color: white;
        margin-top: 2em;
        padding: 1.5em 1em;
    }

    .change-date .btn {
        display: block;
        margin: auto;
        font-weight: bold;
        border-width: 0.15em;
        width: 100%;
        max-width: 260px;
    }

</style>
